import { render, staticRenderFns } from "./BlocoSkeletonDadosGerais.vue?vue&type=template&id=300dca6d&lang=pug"
import script from "./BlocoSkeletonDadosGerais.vue?vue&type=script&lang=js"
export * from "./BlocoSkeletonDadosGerais.vue?vue&type=script&lang=js"
import style0 from "./BlocoSkeletonDadosGerais.vue?vue&type=style&index=0&id=300dca6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports